import { getFilterIds } from "@tIntermatic/Services/DocumentsFilterService";
import { DocumentListFilterState } from "@tIntermatic/Store/Components/DocumentListFilter/DocumentListFilterState";

export const getDocumentListFilters = () => {
    const documentListFilter: DocumentListFilterState = {
        typeFilters: getFilterIds("doctype"),
        langFilters: getFilterIds("doclang"),
    };
    return documentListFilter;
};
